import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { GeneralWPService } from "src/app/core/http/web/generalWp.service";

@Component({
  selector: "app-web",
  templateUrl: "./web.component.html",
  styleUrls: ["./web.component.css"]
})
export class WebComponent implements OnInit {
  public data: any;
  public loarChild: any;
  public loadPage: boolean;

  constructor(private wpServ: GeneralWPService, private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;
        if (url.includes('/m/seguros/resultados/destino?dateFrom=')) {
          sessionStorage.setItem('url', event.urlAfterRedirects);
        } else if (url.includes('/m/seguros/step-one') || url.includes('/seguros/gracias_seguros?')) {

        } else {
          sessionStorage.clear();
        }
      }
    });

    this.getGeneralOptions();
  }

  getGeneralOptions() {
    this.wpServ.getGeneralOptions().subscribe(
      data => {
        this.data = data.data;
        this.loadPage = true;
        this.loarChild = false;
      },
      err => {
        console.error("Error en serv getGeneralOptions", err);
        this.loadPage = true;
        this.loarChild = true;
      }
    );
  }

  ngOnInit() {}

  showMoreInfo() {
    // console.log("MoreInfoShow");
  }
}
